import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs/Rx";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../environments/environment";
import { appService } from '../../../app/_services/app.service';
@Injectable()
export class AuthGuard implements CanActivate {
    checkDataForDate: any = {}
    APIUrl: any = environment.apiUrl;
    loginPageUrl = environment.apiUrl == 'https://sawariya.ifreightbox.net/' || environment.apiUrl == 'https://ximble.ifreightbox.net/' ? '/NewLogin' : '/login'
    constructor(
        private _router: Router,
        private _userService: UserService,
        private cookieService: CookieService,
        private _appService: appService
    ) {
    }

    handleError(error: any) {
        let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return Observable.throw(error);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        // let currentUser = JSON.parse(this.cookieService.get("User") || "{}");

        return this._userService.verify().map(
            data => {
                if (data !== null) {
                    //logged in so return true
                    return true;
                }
                //error when verify so redirect to login page with the return url
                this._router.navigate([this.loginPageUrl], { queryParams: { returnUrl: state.url } });
                return false;
            },
            error => {
                // error when verify so redirect to login page with the return url
                this._router.navigate([this.loginPageUrl], { queryParams: { returnUrl: state.url } });
                return false;
            }).catch((error: any) => {
                this._router.navigate([this.loginPageUrl], { queryParams: { returnUrl: state.url } });
                let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
                return Observable.throw(error);
            });
    }




}